import axios from 'axios';

import sanitizeHeader from 'helpers/sanitizeHeader';

const invalidTokenValues = new Set(['', 'null', 'undefined']);

export const getAuthorizationHeader = access => {
  const sanitizedAccess = sanitizeHeader(access);
  if (invalidTokenValues.has(sanitizedAccess)) return null;
  return `Bearer ${sanitizedAccess}`;
};

export const clearAuthorizationHeader = () => {
  delete axios.defaults.headers.common.Authorization;
};

export const setAuthorizationHeader = access => {
  const authorization = getAuthorizationHeader(access);
  if (!authorization) {
    clearAuthorizationHeader();
    return null;
  }
  axios.defaults.headers.common.Authorization = authorization;
  return authorization;
};
